import { combineReducers } from 'redux';
import CoreReduxStore from '@/core/reducers/CoreReduxStore';
// service
import ContactUsService from '@/cms/services/ContactUsService'
// interface
import TServiceStore from '@/core/types/TServiceStore';


const ContactUsServiceStore = ({ screenCode }:TServiceStore ) => {
    const reduxStorages = new CoreReduxStore({ screenCode: screenCode, serviceCode: ContactUsService.code });

    return combineReducers({

        ...reduxStorages.POST()
    
    });
}

export default ContactUsServiceStore;
